import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Avatar,
	Box,
	Button,
	Chip,
	Stack,
	Typography,
} from '@mui/material';
import React, { useMemo, useState } from 'react';
import ContactSection from './ContactSection';
import { Add } from '@mui/icons-material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { openDialog } from '@/features/dialog/dialogSlice';
import { useListContactsQuery } from '@/features/contacts/contactsApi';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

const ContactDetails = () => {
	const { clientId } = useParams();
	const dispatch = useDispatch();

	const contactsQuery = useListContactsQuery(clientId, {
		skip: !clientId,
	});

	const contacts = useMemo(() => {
		const data = (contactsQuery.data ?? []).slice();
		data.sort(
			(a, b) =>
				(b.isMainContact ? 1 : 0) - (a.isMainContact ? 1 : 0) ||
				(a.Name ?? a.Addressee ?? '').localeCompare(b.Name ?? b.Addressee ?? ''),
		);
		return data;
	}, [contactsQuery.data]);

	const [expanded, setExpanded] = useState(false);
	const handleAccordionChange = (contactId) => (event, isExpanded) => {
		setExpanded(isExpanded ? contactId : null);
	};

	return (
		<>
			<Box display='flex' justifyContent='flex-end' mb={2}>
				<Button
					variant='tab_header'
					startIcon={<Add />}
					onClick={() => dispatch(openDialog('contact'))}
				>
					Add Contact
				</Button>
			</Box>

			<Stack spacing={2} ml={1.5} mt={5}>
				<Stack
					direction='row'
					spacing={2}
					alignItems='center'
					sx={{ marginBottom: 3, padding: '16' }}
				>
					<Typography variant='details_header'>Contact Details</Typography>
				</Stack>
				{contacts.length === 0 ? (
					<Typography variant='body2' color='textSecondary' sx={{ ml: 1 }}>
						No contact associated.
					</Typography>
				) : (
					contacts.map((contact, index) => (
						<Accordion
							key={`contact-accordion-${contact.Id}`}
							expanded={expanded === contact.Id}
							onChange={handleAccordionChange(contact.Id)}
							sx={{ background: 'none', boxShadow: 'none' }}
						>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls={`panel-${index}-content`}
								id={`panel-${index}-header`}
								sx={{ background: 'none' }}
							>
								<Box
									sx={{
										display: 'flex',
										alignItems: 'center',
										gap: 2,
									}}
								>
									<Avatar sx={{ width: 48, height: 48 }}>
										<AccountCircleIcon sx={{ fontSize: 32, color: 'white' }} />
									</Avatar>
									<Box>
										<Stack direction='row' alignItems='center' spacing={1}>
											<Typography variant='h6' fontWeight='bold'>
												{contact?.Name ?? contact?.Addressee}
											</Typography>

											{contact?.isMainContact && (
												<Chip
													label='Primary contact'
													color='primary'
													size='small'
												/>
											)}
										</Stack>

										{contact?.Email && (
											<Typography variant='body2' color='textSecondary'>
												{contact?.Email}
											</Typography>
										)}
									</Box>
								</Box>
							</AccordionSummary>
							<AccordionDetails sx={{ background: 'none' }}>
								<ContactSection {...{ contact }} />
							</AccordionDetails>
						</Accordion>
					))
				)}
			</Stack>
		</>
	);
};

export default ContactDetails;
